import React, { Component } from 'react';
import AbstractInput from '../abstractInput/abstractInput.jsx';

class Input extends Component {
  render() {
    return <AbstractInput {...this.props} />;
  }
}
export default Input;
